const CredibilityLine = () => {
  return (
    <section className="py-12">
      <div className="container-narrow">
        <p data-reveal className="text-center text-sm text-muted-foreground">
          Built for real estate professionals who rely on trust, referrals, and inbound calls.
        </p>
      </div>
    </section>
  );
};

export default CredibilityLine;
